import axios, { AxiosRequestConfig } from "axios";
import { useGeneralStore } from "@/stores/commons/index";
import { storeToRefs } from "pinia";

interface FetchProps {
	url: string;
	params?: AxiosRequestConfig;
}

export const useFetch = async ({ url, params }: FetchProps) => {
	const storeGeneral = useGeneralStore();
	const { loaderStatus } = storeToRefs(storeGeneral);
	let data: any = null;
	let error: any = null;
	loaderStatus.value = true;
	await axios({
		url: url,
		...params
	})
		.then((res) => {
			data = res.data;
			loaderStatus.value = false;
		})
		.catch((err) => {
			error = err;
			loaderStatus.value = false;
		});

	return { data, error };
};
